module.exports = __webpack_public_path__ + "static/media/russia.bbb771a1.svg";